/**
 * This enum is used for sending the user's rate to the backend
 */
export enum ChatbotInteractionRateEnum {
    LIKE = 'LIKE',
    DISLIKE = 'DISLIKE',
    NONE = 'NONE'
}
